<section role="region" class="cej-benefit-from-it">
  <article class="cej-benefit-from-it__article">
    <h2 role="heading" class="cej-benefit-from-it__article__title">
      <span class="line-break"> Le Contrat d&apos;Engagement Jeune </span>
      c&apos;est fait pour moi si&nbsp;:
    </h2>

    <ul class="cej-benefit-from-it__article__conditions">
      <li
        *ngFor="let condition of conditions; trackBy: trackByConditionId"
        class="cej-benefit-from-it__article__conditions__item"
        wizAos
        animationName="fade-bottom"
      >
        <span class="cej-benefit-from-it__tick" aria-hidden="true">
          <mat-icon svgIcon="valid" class="cej-benefit-from-it__tick__icon"></mat-icon>
        </span>
        <div>
          <em *ngIf="condition.emphasis as emphasis" class="cej-benefit-from-it__article__conditions__item__emphasis">
            {{ emphasis }}
          </em>
          <ng-container *ngIf="condition.text as text">{{ text }}</ng-container>
        </div>
      </li>
    </ul>
    <button
      class="btn cej-benefit-from-it__button"
      type="button"
      (click)="buttonClicked()"
      wizAos
      animationName="fade-bottom"
    >
      Je me lance
      <mat-icon svgIcon="chevron_right" role="presentation"></mat-icon>
    </button>
  </article>
</section>
